<script lang="ts">
    import {Link} from "svelte-navigator";
    import type {ReRouteDetailsData} from "../api/projects/data/reroute/ReRouteDetailsData";
    import {appManager} from "../AppManager";

    export let rerouteData: ReRouteDetailsData;

    let url: string = `${appManager.PublicUrl}routeplanner/${rerouteData.id}`;
</script>
<div class="col-12 d-flex">
    <div class="card mb-6 shadow-light-lg lift lift-lg">
        <a href={url} class="card-body">
            <h3>
                <div class="bd-highlight pt-1 min-width-name">
                    {@html rerouteData.name ?? ""}
                </div>
            </h3>

            <div class="mb-0 text-muted">
                {@html rerouteData.description ?? ""}
            </div>
        </a>
    </div>
</div>

<style>
    .min-width-name {
        min-width: 50%;
    }
</style>
